/* */
/**
 * @module actions/Upgrade
 */
import { createAction } from 'typesafe-actions';

import { Actions as PaymentsActions } from './constants';

type ListenerAndSubscriptionReadyParams = $TSFixMe;

interface ListenerAndSubscriptionReadyPayload {
  authType: ListenerAndSubscriptionReadyParams;
}

export const listenerAndSubscriptionReady = createAction(
  PaymentsActions.LISTENER_AND_SUBSCRIPTION_READY,
  (authType: ListenerAndSubscriptionReadyParams) => ({ authType }),
)<ListenerAndSubscriptionReadyPayload>();
export type ListenerAndSubscriptionReadyAction = ReturnType<typeof listenerAndSubscriptionReady>;

export const resetPaypalStatus = createAction(PaymentsActions.RESET_PAYPAL_STATUS)();
export type ResetPaypalStatusAction = ReturnType<typeof resetPaypalStatus>;

export const resetInvalidCreditCardStatus = createAction(
  PaymentsActions.RESET_INVALID_CREDIT_CARD_STATUS,
)();
export type ResetInvalidCreditCardStatusAction = ReturnType<typeof resetInvalidCreditCardStatus>;

export const resetCreditCardForm = createAction(PaymentsActions.CREDIT_CARD_FORM_RESET)();
export type CreditCardFormResetAction = ReturnType<typeof resetCreditCardForm>;

export const hasFinishedPurchase = createAction(PaymentsActions.FINISH_ACQUIRE_PRODUCT)();
export type FinishAcquireProductAction = ReturnType<typeof hasFinishedPurchase>;

interface AcquireOfferSuccessParams {
  specialOfferToken: $TSFixMe;
  sku: $TSFixMe;
}

export const acquireOfferSuccess = createAction(
  PaymentsActions.ACQUIRE_OFFER_SUCCESS,
  (params: AcquireOfferSuccessParams) => params,
)<AcquireOfferSuccessParams>();
export type AcquireOfferSuccessAction = ReturnType<typeof acquireOfferSuccess>;

interface ToggleSwitchingPlansPayload {
  isSwitchingPlans: boolean;
}

export const switchingPlans = createAction(PaymentsActions.TOGGLE_SWITCHING_PLANS, () => ({
  isSwitchingPlans: true,
}))<ToggleSwitchingPlansPayload>();
export const stopSwitchingPlans = createAction(PaymentsActions.TOGGLE_SWITCHING_PLANS, () => ({
  isSwitchingPlans: false,
}))<ToggleSwitchingPlansPayload>();
export type ToggleSwitchingPlansAction = ReturnType<
  typeof switchingPlans | typeof stopSwitchingPlans
>;

export const updatingBillingInfo = createAction(PaymentsActions.UPDATING_BILLING_INFO)();
export type UpdatingBillingInfoAction = ReturnType<typeof updatingBillingInfo>;

export const stopUpdatingBillingInfo = createAction(PaymentsActions.STOP_UPDATING_BILLING_INFO)();
export type StopUpdatingBillingInfoAction = ReturnType<typeof stopUpdatingBillingInfo>;

/**
 * action notifying of the intent to get subscription info (new version)
 *
 * @returns {object} - returns pertinent data - subscriptionInfoV1 will be deprecated
 */
export const getSubscriptionInfoV2 = createAction(PaymentsActions.GET_SUBSCRIPTION_INFO_V2)();
export type GetSubscriptionInfoV2Action = ReturnType<typeof getSubscriptionInfoV2>;

export const resetUpdatedBillingInfo = createAction(PaymentsActions.RESET_UPDATED_BILLING_INFO)();
export type ResetUpdatedBillingInfoAction = ReturnType<typeof resetUpdatedBillingInfo>;

type CancelSubscriptionParams = $TSFixMe;

interface CancelSubscriptionPayload {
  password: CancelSubscriptionParams;
}

export const cancelSubscription = createAction(
  PaymentsActions.CANCEL_SUBSCRIPTION,
  (password: CancelSubscriptionParams) => ({ password }),
)<CancelSubscriptionPayload>();
export type CancelSubscriptionAction = ReturnType<typeof cancelSubscription>;

export const cancelSubscriptionWithoutPassword = createAction(
  PaymentsActions.CANCEL_SUBSCRIPTION,
)();
export type CancelSubscriptionWithoutPasswordAction = ReturnType<
  typeof cancelSubscriptionWithoutPassword
>;

export const logCancelSubscriptionExposureEvent = createAction(
  PaymentsActions.LOG_CANCEL_SUBSCRIPTION_EXPOSURE_EVENT,
)();
export type LogCancelSubscriptionExposureEventAction = ReturnType<
  typeof logCancelSubscriptionExposureEvent
>;

export const logPaymentUpdatesExposureEvent = createAction(
  PaymentsActions.LOG_PAYMENT_UPDATES_EXPOSURE_EVENT,
)();
export type LogPaymentUpdatesExposureEventAction = ReturnType<
  typeof logPaymentUpdatesExposureEvent
>;

export const logSwitchPlansModalUpdatesExposureEvent = createAction(
  PaymentsActions.LOG_SWITCH_PLANS_MODAL_UPDATES_EXPOSURE_EVENT,
)();
export type LogSwitchPlansModalUpdatesExposureEventAction = ReturnType<
  typeof logSwitchPlansModalUpdatesExposureEvent
>;

type DeleteCreditCardParams = $TSFixMe;

interface DeleteCreditCardPayload {
  password: DeleteCreditCardParams;
}

export const deleteCreditCard = createAction(
  PaymentsActions.DELETE_CREDIT_CARD,
  (password: DeleteCreditCardParams) => ({ password }),
)<DeleteCreditCardPayload>();
export type DeleteCreditCardAction = ReturnType<typeof deleteCreditCard>;

export const resubscribe = createAction(PaymentsActions.RESUBSCRIBE)();
export type ResubscribeAction = ReturnType<typeof resubscribe>;

export const updateCreditCardInfo = createAction(PaymentsActions.UPDATE_CREDIT_CARD_INFO)();
export type UpdateCreditCardInfoAction = ReturnType<typeof updateCreditCardInfo>;

interface AcquireOfferParams {
  tier: $TSFixMe;
  discountType: $TSFixMe;
  paymentProvider: $TSFixMe;
  durationType: $TSFixMe;
  specialOfferCode: $TSFixMe;
  getSpecialOfferType: $TSFixMe;
  paypalPurchaseInfo: $TSFixMe;
  vendorSku: $TSFixMe;
  backingProductIdentifier: $TSFixMe;
}

export const acquireOffer = createAction(
  PaymentsActions.ACQUIRE_OFFER,
  (params: AcquireOfferParams) => params,
)<AcquireOfferParams>();
export type AcquireOfferAction = ReturnType<typeof acquireOffer>;

interface PrepareToAcquireOfferParams {
  tier: $TSFixMe;
  discountType: $TSFixMe;
  paymentProvider: $TSFixMe;
  durationType: $TSFixMe;
  specialOfferCode: $TSFixMe;
}

export const prepareToAcquireOffer = createAction(
  PaymentsActions.PREPARE_TO_ACQUIRE_OFFER,
  (params: PrepareToAcquireOfferParams) => params,
)<PrepareToAcquireOfferParams>();
export type PrepareToAcquireOfferAction = ReturnType<typeof prepareToAcquireOffer>;

interface UpgradeOfferedParams {
  sourceId: $TSFixMe;
  sourceType: $TSFixMe;
}

export const upgradeOffered = createAction(
  PaymentsActions.UPGRADE_OFFERED,
  (params: UpgradeOfferedParams) => params,
)<UpgradeOfferedParams>();
export type UpgradeOfferedAction = ReturnType<typeof upgradeOffered>;

export const setSource = createAction(
  PaymentsActions.SET_SOURCE,
  (params: UpgradeOfferedParams) => {
    return params;
  },
)<UpgradeOfferedParams>();
export type SetSourceAction = ReturnType<typeof setSource>;

export const cancelCurrentProduct = createAction(PaymentsActions.CANCEL_CURRENT_PRODUCT)();
export type CancelCurrentProductAction = ReturnType<typeof cancelCurrentProduct>;

export const exitFromFamilyPlan = createAction(PaymentsActions.EXIT_FROM_FAMILY_PLAN)();
export type ExitFromFamilyPlanAction = ReturnType<typeof exitFromFamilyPlan>;

type FamilyPlanCreateInviteParams = $TSFixMe;

interface FamilyPlanCreateInvitePayload {
  emailAddress: FamilyPlanCreateInviteParams;
}

export const createFamilyPlanInvite = createAction(
  PaymentsActions.FAMILY_PLAN_CREATE_INVITE,
  (emailAddress: FamilyPlanCreateInviteParams) => ({ emailAddress }),
)<FamilyPlanCreateInvitePayload>();
export type FamilyPlanCreateInviteAction = ReturnType<typeof createFamilyPlanInvite>;

type FamilyPlanResendInviteParams = $TSFixMe;

interface FamilyPlanResendInvitePayload {
  emailAddress: FamilyPlanResendInviteParams;
}

export const resendFamilyPlanInvite = createAction(
  PaymentsActions.FAMILY_PLAN_RESEND_INVITE,
  (emailAddress: FamilyPlanResendInviteParams) => ({ emailAddress }),
)<FamilyPlanResendInvitePayload>();
export type FamilyPlanResendInviteAction = ReturnType<typeof resendFamilyPlanInvite>;

interface FamilyPlanRevokeInvitePayload {
  inviteToken: $TSFixMe;
  emailAddress: $TSFixMe;
}

export const revokeFamilyPlanInvite = createAction(
  PaymentsActions.FAMILY_PLAN_REVOKE_INVITE,
  (inviteToken: $TSFixMe, emailAddress: $TSFixMe) => ({ inviteToken, emailAddress }),
)<FamilyPlanRevokeInvitePayload>();
export type FamilyPlanRevokeInviteAction = ReturnType<typeof revokeFamilyPlanInvite>;

interface FamilyPlanRemoveChildPayload {
  childListenerId: $TSFixMe;
  emailAddress: $TSFixMe;
}

export const removeChildFromFamilyPlan = createAction(
  PaymentsActions.FAMILY_PLAN_REMOVE_CHILD,
  (childListenerId: $TSFixMe, emailAddress: $TSFixMe) => ({ childListenerId, emailAddress }),
)<FamilyPlanRemoveChildPayload>();
export type FamilyPlanRemoveChildAction = ReturnType<typeof removeChildFromFamilyPlan>;

interface StartManagingFamilyPlanAccountsPayload {
  isManaging: $TSFixMe;
  isInviting: $TSFixMe;
}

export const startManagingFamilyPlanAccounts = createAction(
  PaymentsActions.START_MANAGING_FAMILY_PLAN_ACCOUNTS,
  (isManaging: $TSFixMe, isInviting: $TSFixMe) => ({ isManaging, isInviting }),
)<StartManagingFamilyPlanAccountsPayload>();
export type StartManagingFamilyPlanAccountsAction = ReturnType<
  typeof startManagingFamilyPlanAccounts
>;

export const stopManagingFamilyPlanAccounts = createAction(
  PaymentsActions.STOP_MANAGING_FAMILY_PLAN_ACCOUNTS,
)();
export type StopManagingFamilyPlanAccountsAction = ReturnType<
  typeof stopManagingFamilyPlanAccounts
>;

interface LogUpgradePageEventParams extends $TSFixMe {}

export const logUpgradePageEvent = createAction(
  PaymentsActions.LOG_UPGRADE_PAGE_EVENT,
  (params: LogUpgradePageEventParams) => params,
)<LogUpgradePageEventParams>();
export type LogUpgradePageEventAction = ReturnType<typeof logUpgradePageEvent>;

interface UpgradeConfirmationParams extends $TSFixMe {}

export const onUpgradeCompleted = createAction(
  PaymentsActions.UPGRADE_CONFIRMATION,
  (params: UpgradeConfirmationParams) => params,
)<UpgradeConfirmationParams>();
export type UpgradeConfirmationAction = ReturnType<typeof onUpgradeCompleted>;

export const enterPartnerUpgradeFlow = createAction(PaymentsActions.ENTER_PARTNER_UPGRADE_FLOW)();
export type EnterPartnerUpgradeFlowAction = ReturnType<typeof enterPartnerUpgradeFlow>;

interface RequestPartnerUpgradeParams {
  tier: $TSFixMe;
  discountType: $TSFixMe;
}

export const requestPartnerUpgrade = createAction(
  PaymentsActions.REQUEST_PARTNER_UPGRADE,
  (params: RequestPartnerUpgradeParams) => params,
)<RequestPartnerUpgradeParams>();
export type RequestPartnerUpgradeAction = ReturnType<typeof requestPartnerUpgrade>;

interface AnonymousStartTrialClickedParams {
  tier: $TSFixMe;
  discountType: $TSFixMe;
  shouldSetAnon: $TSFixMe;
  redirectAfterLogin: $TSFixMe;
}

export const anonymousStartTrialClicked = createAction(
  PaymentsActions.ANONYMOUS_START_TRIAL_CLICKED,
  (params: AnonymousStartTrialClickedParams) => params,
)<AnonymousStartTrialClickedParams>();
export type AnonymousStartTrialClickedAction = ReturnType<typeof anonymousStartTrialClicked>;

interface SelectOfferParams {
  tier: $TSFixMe;
  discountType: $TSFixMe;
}

export const selectOffer = createAction(
  PaymentsActions.SELECT_OFFER,
  (params: SelectOfferParams) => params,
)<SelectOfferParams>();
export type SelectOfferAction = ReturnType<typeof selectOffer>;

type SelectPaymentProviderParams = $TSFixMe;

interface SelectPaymentProviderPayload {
  paymentProvider: SelectPaymentProviderParams;
}

export const selectPaymentProvider = createAction(
  PaymentsActions.SELECT_PAYMENT_PROVIDER,
  (paymentProvider: SelectPaymentProviderParams) => ({ paymentProvider }),
)<SelectPaymentProviderPayload>();
export type SelectPaymentProviderAction = ReturnType<typeof selectPaymentProvider>;

export const clearSelectedOffer = createAction(PaymentsActions.CLEAR_SELECTED_OFFER)();
export type ClearSelectedOfferAction = ReturnType<typeof clearSelectedOffer>;

export const setIsAnonymousUpgrade = createAction(PaymentsActions.IS_ANONYMOUS_UPGRADE)();
export type IsAnonymousUpgradeAction = ReturnType<typeof setIsAnonymousUpgrade>;

export const loadPaymentsData = createAction(PaymentsActions.LOAD_PAYMENTS_DATA)();
export type LoadPaymentsDataAction = ReturnType<typeof loadPaymentsData>;

interface ProcessUpgradeAuthenticationParams {
  tierSlug: $TSFixMe;
  subTierSlug: $TSFixMe;
}

export const processUpgradeAuthentication = createAction(
  PaymentsActions.PROCESS_UPGRADE_AUTHENTICATION,
  (params: ProcessUpgradeAuthenticationParams) => params,
)<ProcessUpgradeAuthenticationParams>();
export type ProcessUpgradeAuthenticationAction = ReturnType<typeof processUpgradeAuthentication>;

interface ProcessUpgradeParams {
  tierSlug: $TSFixMe;
  subTierSlug: $TSFixMe;
}

export const processUpgrade = createAction(
  PaymentsActions.PROCESS_UPGRADE,
  (params: ProcessUpgradeParams) => params,
)<ProcessUpgradeParams>();
export type ProcessUpgradeAction = ReturnType<typeof processUpgrade>;

export const enterSubscriptionManagement = createAction(
  PaymentsActions.ENTER_SUBSCRIPTION_MANAGEMENT,
)();
export type EnterSubscriptionManagementAction = ReturnType<typeof enterSubscriptionManagement>;

interface EnterFamilyPlanManagementParams {
  currentPath: $TSFixMe;
}

export const enterFamilyPlanManagement = createAction(
  PaymentsActions.ENTER_FAMILY_PLAN_MANAGEMENT,
  (params: EnterFamilyPlanManagementParams) => params,
)<EnterFamilyPlanManagementParams>();
export type EnterFamilyPlanManagementAction = ReturnType<typeof enterFamilyPlanManagement>;

interface DisplayMobileMessageParams {
  message: $TSFixMe;
}

export const setMobileMessage = createAction(
  PaymentsActions.DISPLAY_MOBILE_MESSAGE,
  (params: DisplayMobileMessageParams) => params,
)<DisplayMobileMessageParams>();
export type DisplayMobileMessageAction = ReturnType<typeof setMobileMessage>;

export const clearMobileMessage = createAction(PaymentsActions.CLEAR_MOBILE_MESSAGE)();
export type ClearMobileMessageAction = ReturnType<typeof clearMobileMessage>;

interface OpenSwitchPlanModalParams {
  selectedTier: $TSFixMe;
  selectedDiscountType: $TSFixMe;
  selectedDurationType: $TSFixMe;
}

export const openSwitchPlanModal = createAction(
  PaymentsActions.OPEN_SWITCH_PLAN_MODAL,
  (params: OpenSwitchPlanModalParams) => params,
)<OpenSwitchPlanModalParams>();
export type OpenSwitchPlanModalAction = ReturnType<typeof openSwitchPlanModal>;

export const openCancelSubscriptionModal = createAction(
  PaymentsActions.OPEN_CANCEL_SUBSCRIPTION_MODAL,
)();
export type OpenCancelSubscriptionModalAction = ReturnType<typeof openCancelSubscriptionModal>;

interface SwitchPlanParams {
  vendorSku: $TSFixMe;
  backingProductIdentifier: $TSFixMe;
  paymentProvider: $TSFixMe;
  tier: $TSFixMe;
  discountType: $TSFixMe;
  durationType: $TSFixMe;
}

export const switchPlan = createAction(
  PaymentsActions.SWITCH_PLAN,
  (params: SwitchPlanParams) => params,
)<SwitchPlanParams>();
export type SwitchPlanAction = ReturnType<typeof switchPlan>;

export const enterPaypalComplete = createAction(PaymentsActions.PAYPAL_COMPLETE)();
export type PaypalCompleteAction = ReturnType<typeof enterPaypalComplete>;

export const setPaypalComplete = createAction(PaymentsActions.SET_PAYPAL_COMPLETE)();
export type SetPaypalCompleteAction = ReturnType<typeof setPaypalComplete>;

export const waitForSubscriptionInfo = createAction(PaymentsActions.WAIT_FOR_SUBSCRIPTION_INFO)();
export type WaitForSubscriptionInfoAction = ReturnType<typeof waitForSubscriptionInfo>;

export const partnerUpgradeConfirmListener = createAction(
  PaymentsActions.PARTNER_UPGRADE_CONFIRM_LISTENER,
)();
export type PartnerUpgradeConfirmListenerAction = ReturnType<typeof partnerUpgradeConfirmListener>;

interface InitiatePartnerUpgradeParams {
  entitlementId: $TSFixMe;
  tier: $TSFixMe;
  partnerName: $TSFixMe;
}

export const initiatePartnerUpgrade = createAction(
  PaymentsActions.INITIATE_PARTNER_UPGRADE,
  (params: InitiatePartnerUpgradeParams) => params,
)<InitiatePartnerUpgradeParams>();
export type InitiatePartnerUpgradeAction = ReturnType<typeof initiatePartnerUpgrade>;

export const exitPartnerUpgrade = createAction(PaymentsActions.EXIT_PARTNER_UPGRADE)();
export type ExitPartnerUpgradeAction = ReturnType<typeof exitPartnerUpgrade>;

interface UpgradeCtaClickParams {
  tier: $TSFixMe;
  discountType: $TSFixMe;
  isTrial: $TSFixMe;
}

export const upgradeCtaClicked = createAction(
  PaymentsActions.UPGRADE_CTA_CLICK,
  (params: UpgradeCtaClickParams) => params,
)<UpgradeCtaClickParams>();
export type UpgradeCtaClickAction = ReturnType<typeof upgradeCtaClicked>;

interface UpgradeDiscountPlanLinkClickedParams {
  tier: $TSFixMe;
  discountType: $TSFixMe;
  isTrial: $TSFixMe;
}

export const upgradeDiscountPlanLinkClicked = createAction(
  PaymentsActions.UPGRADE_DISCOUNT_PLAN_LINK_CLICKED,
  (params: UpgradeDiscountPlanLinkClickedParams) => params,
)<UpgradeDiscountPlanLinkClickedParams>();
export type UpgradeDiscountPlanLinkClickedAction = ReturnType<
  typeof upgradeDiscountPlanLinkClicked
>;

export const selectReverifyNow = createAction(PaymentsActions.REVERIFY_LINK_CLICKED)();
export type ReverifyLinkClickedAction = ReturnType<typeof selectReverifyNow>;
